// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"1d313fe8","677":"fd47212d","688":"803a53fd"}[chunkId] + ".chunk.css";
};